import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
  },
  beforeTable: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  entityDropdown: {
    width: '230px',
    paddingRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-end'
  },
}));